<template>
  <!-- Top header -->
  <header class="header-area header-three">
    <div class="header-top second-header d-none d-md-block">
      <div class="containerx">
        <div class="row align-items-center" style="--bs-gutter-x: 0px">
          <div class="col-lg-3 col-md-3 d-none d-lg-block">
            <div class="header-social">
              <a class="navbar-brand" href="/">
                <img src="/vf/images/logo/vf_logo.png" class="main-logo" alt="logo" />
              </a>
              <!--  /social media icon redux -->
            </div>
          </div>
          <div class="col-lg-8 col-md-8 d-none d-lg-block text-right">
            <div class="header-right-content">
              <div class="list">
                <ul>
                  <li>
                    <a href="https://rdc.eshala.co.in/jobs" target="_blank">Career</a>
                  </li>
                  <li>
                    <a href="https://rdc.eshala.co.in/welcome/library_books" target="_blank">Library</a>
                  </li>
                  <li>
                    <a href="https://rdc.eshala.co.in/site/login" target="_blank">Staff Login</a>
                  </li>
                  <li>
                    <a href="https://rdc.eshala.co.in/site/userlogin" target="_blank">Student Login</a>
                  </li>
                  <li><router-link to="/applynow">Admission</router-link></li>
                  <li><router-link to="/gallery">Gallery</router-link></li>
                  <li><router-link to="/contact">Contact Us</router-link></li>
                  <li><router-link to="/donate">Contribute</router-link></li>
                  <li class="contact-and-address">
                    <div class="social-media" style="margin: 0;">
                      <ul>
                        <li><a href="https://www.facebook.com/womencollegereengus?mibextid=ZbWKwL" target="_blank"><i
                              style="font-size: large;" class="ri-facebook-fill"></i></a></li>
                        <li><a href="https://www.instagram.com/vedantacollegereengus?igsh=ZjRrbmF2ajNlZWFu"
                            target="_blank"><i class="ri-instagram-fill" style="font-size: large;"></i></a></li>
                        <li><a
                            href="https://www.linkedin.com/in/vedanta-p-g-girls-college-r-33a4a6253?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=android_app"
                            target="_blank"><i class="ri-linkedin-fill" style="font-size: large;"></i></a></li>
                        <li><a href="https://youtube.com/@vedantapggirlscollegereeng9330?si=MgxBLE2ibuybHhR4"
                            target="_blank"><i class="ri-youtube-fill" style="font-size: large;"></i></a></li>
                        <li><a
                            href="https://wa.me/91978537169?text=Welcome%20to%20Vedanta%20PG%20Girls%20College,%20Reengus.%20%0AHow%20can%20I%20assist%20you%20today%20?"
                            target="_blank"><i class="ri-whatsapp-fill" style="font-size: large;"></i></a></li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <Menubar :model="items">
    <template #start>
      <img alt="logo" src="/vf/images/logo.png" height="60" class="mr-2" />
    </template>
    <template #item="{ item, props, hasSubmenu }">
      <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
        <a v-ripple :href="href" v-bind="props.action" @click="navigate">
          <span :class="item.icon" />
          <span class="ml-2">{{ item.label }}</span>
        </a>
      </router-link>
      <a v-else v-ripple :href="item.url" :target="item.target" v-bind="props.action">
        <span :class="item.icon" />
        <span class="ml-2">{{ item.label }}</span>
        <span v-if="hasSubmenu" class="pi pi-fw pi-angle-down ml-2" />
      </a>
    </template>
  </Menubar>

  <div class="alert alert-success" role="alert">
    <Vue3Marquee :duration="20" :pause-on-hover="true">
      <a href="https://rdc.eshala.co.in/page/enquiry" style="padding: 0 50px; font-size: 1rem; color: darkgreen"
        v-for="(word, index) in marqueeItems" :key="index">
        {{ word.text }}
      </a>
    </Vue3Marquee>
  </div>
</template>

<script>
import Menubar from "primevue/menubar";
import { Vue3Marquee } from "vue3-marquee";

export default {
  name: "AppHeader",
  components: {
    Menubar,
    Vue3Marquee,
  },
  data() {
    return {
      items: [
        {
          label: "Home",
          route: "/",
        },
        {
          label: "About us",
          items: [
            {
              label: "Vedanta Foundation",
              url: "https://vedantafoundation.org/",
            },
            {
              label: "About College",
              route: "/aboutcollege",
            },
            {
              label: "Campus",
              route: "/campus",
            },
            {
              label: "Leadership Message",
              route: "/leadershipmessage",
            },
            {
              label: "Principal Message",
              route: "/principalmessage",
            },
            {
              label: "Affiliation",
              route: "/affiliation",
            },
            {
              label: "Organogram",
              route: "/organogram",
            },
            {
              label: "Governing Body",
              route: "/governingbody",
            },
          ],
        },
        {
          label: "Academics",
          items: [
            {
              label: "Departments",
              route: "/department",
            },
            {
              label: "Syllabus",
              route: "/syllabus",
            },
            {
              label: "Subjects",
              route: "/subjects",
            },
            {
              label: "Skill Courses",
              items: [
                {
                  label: "Vocational Training Center",
                  route: "/vocationalcenter",
                },
                {
                  label: "NIELIT/DLC",
                  route: "/dlc",
                },
              ],
            },
            {
              label: "Academic Calendar",
              route: "/academiccalender",
            },
            {
              label: "Teaching Staff",
              route: "/teachingstaff",
            },
            {
              label: "Non Teaching Staff",
              route: "/nonteachingstaff",
            },
            {
              label: "Collaboration & MOU",
              route: "/collaboration",
            },
            {
              label: "eResources",
              route: "/eresources",
            },
          ],
        },
        {
          label: "Admission",
          items: [
            {
              label: "Apply Now",
              route: "/applynow",
            },
            {
              label: "Program Offered",
              route: "/programoffered",
            },
            {
              label: "Eligiblity Criteria",
              route: "/eligiblitycriteria",
            },
            {
              label: "Fee Details",
              route: "/feedetails",
            },
            {
              label: "Scholarship",
              route: "/scholarship",
            },
            {
              label: "College Brochure",
              route: "/collegebrochure",
            },
            {
              label: "Admission Committee",
              route: "/admissioncommittee",
            },
          ],
        },
        {
          label: "Student Corner",
          items: [
            {
              label: "Achievements",
              route: "/achievements",
            },
            {
              label: "Alumni",
              route: "/alumni",
            },
            {
              label: "Placements",
              route: "/placement",
            },
            {
              label: "Cells",
              route: "/cells",
            },
            {
              label: "Policies",
              route: "/policies",
            },
            {
              label: "Mentor-Mentee",
              route: "/mentormentee",
            },
            {
              label: "Toppers",
              route: "/toppers",
            },
            {
              label: "Events",
              url: "https://rdc.eshala.co.in/events",
            },
            {
              label: "Notices",
              url: "https://rdc.eshala.co.in/page/notices",
            },
            {
              label: "News",
              url: "https://rdc.eshala.co.in/page/news",
            }
            // ,
            // {
            //   label: "Student Login",
            //   url: "https://rdc.eshala.co.in/site/userlogin",
            // },
          ],
        },
        {
          label: "Publication",
          items: [
            {
              label:
                "Vedanta Journal of Research and Multidisciplinary Studies",
              url: "https://vjrms.vpggc.ac.in/",
            },
            {
              label: "Newsletter",
              route: "/newsletter",
            },
            {
              label: "News Media",
              route: "/media",
            },
            {
              label: "Editorial Board",
              route: "/editorialboard",
            },
          ],
        },
        {
          label: "IQAC",
          items: [
            {
              label: "About IQAC",
              url: "/vf/documents/naac/others/About_IQAC.pdf",
            },
            {
              label: "IQAC Composition",
              route: "/iqaccomposition",
            },
            {
              label: "IQAC Meetings",
              route: "/iqacmeeting",
            },
            {
              label: "IQAC Notices",
              route: "/iqacnotices",
            },
            {
              label: "AQAR",
              route: "/aqar",
            },
            {
              label: "Clubs",
              route: "/clubcommittee",
            },
            {
              label: "Committee",
              route: "/iqaccommittee",
            },
            {
              label: "Enrichment Initiative",
              route: "/enrichmentinitiative",
            }
          ],
        },
        {
          label: "NAAC/NIRF",
          items: [
            {
              label: "NAAC Certificate",
              route: "/naaccertificate",
            },
            {
              label: "AISHE",
              route: "/aishe",
            },
            {
              label: "SSR Documents",
              route: "/ssrdocuments",
            },
            {
              label: "Institutional Distinctiveness",
              route: "/institutionaldistinctiveness",
            },
            {
              label: "Best Practices",
              route: "/bestpractises",
            },
            {
              label: "Criteria",
              route: "/criteria",
            },
            {
              label: "Peer Review",
              route: "/peerreview",
            },
            {
              label: "NIRF",
              route: "/nirfview",
            },
          ],
        },
      ],
      marqueeItems: [
        {
          id: 1,
          text: "Applications now open for aspiring students for AY 2025-2026. Apply Now.",
        },
      ],
    };
  }
};
</script>
<style>
.p-menubar {
  border: 0;
  padding: 20px;
  font-size: 16px;
  color: #ffffff;
  position: relative;
  font-weight: 600;
  background-color: white;
}

.p-menubar-root-list {
  margin: 0;
}

.p-submenu-list {
  margin: 0;
  padding: 0;
  z-index: 1000;
}

.p-menuitem-link {
  color: #111d5e;
}
</style>
<!-- // 5EHMZ8XMM3q7WQ4Kh77j -->
